import {
  Alert,
  Backdrop,
  Button,
  Chip,
  CircularProgress,
  Icon,
  Snackbar,
} from "@mui/material";
import axios from "axios.js";
import usePageTitle from "app/pageTitle";
import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";
import MDButton from "theme/components/MDButton";
import DataTable from "theme/Tables/DataTable";
import DashboardLayout from "app/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/Navbars/DashboardNavbar";
import Footer from "theme/Footer";

function DawRetailersPage() {
  const pageTitle = `Display & Win - Retailers`;
  usePageTitle(pageTitle);
  const navigate = useNavigate();
  const { ref } = useParams();

  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("error");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };

  const [pageLoaded, setPageLoaded] = useState(false);
  const [retailers, setRetailers] = useState([]);

  function getUrgencyChip(urgency, reference) {
    let text = "Ready";
    let color = "success";
    if (urgency >= 4) {
      text = "Overdue";
      color = "error";
    }

    if (urgency < 4 && urgency > 1) {
      text = "Late";
      color = "warning";
    }

    return (
      <Chip
        size="small"
        label={
          <MDTypography fontSize={12} color="white">
            {text}
          </MDTypography>
        }
        color={color}
        onClick={() => {
          navigate(`/activations/display-win/retailers/${reference}`);
        }}
      />
    );
  }

  const tableTableColumns = [
    // { Header: "#", accessor: "action", align: "left" },
    { Header: "Priority", accessor: "urgency", align: "left" },
    { Header: "Name", accessor: "name", align: "left" },
  ];

  const buildTableRows = (data) => {
    const rows = [];
    data.map((row) => {
      rows.push({
        name: row.name,
        urgency: (
          <MDBox
            onClick={() => {
              navigate(`/activations/display-win/retailers/${row.reference}`);
            }}
          >
            {row.can_visit ? (
              getUrgencyChip(row.urgency, row.reference)
            ) : (
              <Chip
                onClick={() => {
                  navigate(
                    `/activations/display-win/retailers/${row.reference}`,
                  );
                }}
                size="small"
                label={<MDTypography fontSize={12}>Not Ready</MDTypography>}
              />
            )}
          </MDBox>
        ),
        action: (
          <MDButton
            size="small"
            variant="contained"
            color="primary"
            iconOnly
            circular
            onClick={() => {
              navigate(`/activations/display-win/retailers/${row.reference}`);
            }}
          >
            <Icon sx={{ fontWeight: "bold" }}>east</Icon>
          </MDButton>
        ),
      });
      return null;
    });

    return rows;
  };

  useEffect(() => {
    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get(`agents/daw/${ref}/retailers.json`)
        .then((result) => {
          setShowLoading(false);
          if (result.data.status === "success") {
            const rows = buildTableRows(result.data.data.retailers);
            setRetailers(rows);

            setPageLoaded(true);
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);
          }
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg(
            `Unable to complete request. ${
              navigator.onLine
                ? ""
                : "Make sure you have an active internet connection"
            }`,
          );
          setOpen(true);
        });
    };

    fetchData();
  }, []);
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>
      <MDBox mt={1} mb={5}>
        {pageLoaded && (
          <MDBox>
            <MDBox display="flex" justifyContent="space-between">
              <MDBox>
                <Button
                  color="dark"
                  size="small"
                  startIcon={<Icon>west</Icon>}
                  onClick={() => {
                    if (window.history.length > 1) {
                      window.history.back();
                    } else {
                      navigate(`/activations/display-win/${ref}`);
                    }
                  }}
                >
                  Back
                </Button>
              </MDBox>
              <MDBox pt={0.5} px={2}>
                <MDTypography variant="h6" fontSize={16}>
                  Retailers
                </MDTypography>
              </MDBox>
            </MDBox>
            <MDBox mt={1} align="center">
              <DataTable
                table={{ columns: tableTableColumns, rows: retailers }}
                isSorted
                search={false}
                entriesPerPage={false}
                showTotalEntries
                noEndBorder
              />
            </MDBox>
          </MDBox>
        )}
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default DawRetailersPage;
